export const CART_STORAGE_KEY = 'ietsene-cart';
export const STORAGE_DISCLOSURE_KEY = 'ietsene-storage-disclosure';

export function getItem<T>(key: string): T | null {
  try {
    const raw = localStorage.getItem(key);
    if (raw == null) return null;
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}

export function setItem<T>(key: string, value: T): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // Ignore quota exceeded or other storage errors
  }
}
